let idToken = null;

export const tokenStore = {
  set: (token) => {
    idToken = token;
  },
  get: () => idToken,
};
